import * as delegate from 'delegate';
import axios from "axios";

export default class Wishlist {
    private readonly elem: HTMLElement;

    constructor(elem: HTMLElement) {
        this.elem = elem;
    }

    static factory() {
        const wishlist = new Wishlist(document.querySelector('.site-header__favorite .button'));
        wishlist.refresh();

        delegate('[data-action="remove-wishlist"]', 'click', (e) => {
            const target = e.delegateTarget as HTMLElement;

            wishlist.removeProduct(parseInt(target.dataset.idProduct));
        });

        delegate('[data-action="add-wishlist"]', 'click', (e) => {
            const target = e.delegateTarget as HTMLElement;

            if (target.getAttribute('aria-pressed') === 'true') {
                wishlist.removeProduct(parseInt(target.dataset.idProduct));
            } else {
                wishlist.addProduct(parseInt(target.dataset.idProduct));
            }
        });
    }

    public async addProduct(idProduct: number) {
        const formData = new FormData();
        formData.append('action', 'wishlist_add_product');
        formData.append('id_product', idProduct.toString());

        await axios.post('', formData);

        this.refresh();
    }

    public async removeProduct(idProduct: number) {
        const formData = new FormData();
        formData.append('action', 'wishlist_remove_product');
        formData.append('id_product', idProduct.toString());

        await axios.post('', formData);

        document.querySelectorAll(".product-card").forEach((el: HTMLElement) => {
            if(el.getAttribute('data-id-product') == idProduct){
                el.remove();
            }
        });

        this.refresh();
    }


    public refresh() {
        axios.get('', {
            params: {
                action: 'wishlist_get_products_count'
            }
        }).then((response) => {
            if (response.data.success === true) {
                document.querySelectorAll('[data-action="add-wishlist"]').forEach((el: HTMLElement) => {
                    el.setAttribute('aria-pressed', 'false');
                });


                const count = parseInt(response.data.count);
                this.elem.querySelector('i').innerText = count === 0 ? '' : count.toString();
    
                if (count !== 0) {
                    this.elem.classList.add('has-items');
                } else {
                    this.elem.classList.remove('has-items');
                }

                const ids = response.data.ids;
                ids.forEach((id) => {
                    document.querySelectorAll(`[data-action="add-wishlist"][data-id-product="${id}"]`).forEach((el: HTMLElement) => {
                        el.setAttribute('aria-pressed', 'true');
                    });
                });
            }
        });
    }
}

